import React, { useState, useEffect } from 'react';
import { apiClient } from '../services/authService';
import './ReportesErroresEstudiante.css';

function ReportesErroresEstudiante() {
  const [reportes, setReportes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    cargarReportes();
  }, []);

  const cargarReportes = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await apiClient.get('/estudiante/reportes');
      setReportes(res.data);
    } catch (err) {
      console.error('Error al cargar reportes:', err);
      setError('Error loading reports. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const tiposErrorLabels = {
    'respuesta_incorrecta': 'Incorrect answers',
    'error_ortografico': 'Spelling errors',
    'no_funciona': 'Not working correctly',
    'pregunta_confusa': 'Question is confusing',
    'otro': 'Other'
  };

  const estadosLabels = {
    'pendiente': 'Pending',
    'en_revision': 'Under review',
    'resuelto': 'Resolved',
    'rechazado': 'Rejected'
  };

  const estadosColors = {
    'pendiente': '#ffc107',
    'en_revision': '#17a2b8',
    'resuelto': '#28a745',
    'rechazado': '#dc3545'
  };

  if (loading) {
    return (
      <div className="reportes-estudiante-container">
        <div className="reportes-estudiante-loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="reportes-estudiante-container">
        <div className="reportes-estudiante-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="reportes-estudiante-container">
      <div className="reportes-estudiante-header">
        <h2>Error Reports</h2>
        <p className="reportes-estudiante-subtitle">
          View your submitted error reports and their status
        </p>
      </div>

      {reportes.length === 0 ? (
        <div className="reportes-estudiante-empty">
          <div className="reportes-estudiante-empty-icon">⚠️</div>
          <h3>No error reports submitted yet</h3>
          <p>Report errors in exam questions to see them here.</p>
        </div>
      ) : (
        <div className="reportes-estudiante-list">
          {reportes.map((reporte) => (
            <div key={reporte.id} className="reporte-estudiante-card">
              <div className="reporte-estudiante-header">
                <div className="reporte-estudiante-title-section">
                  <h3>
                    {reporte.numero_pregunta 
                      ? `Question #${reporte.numero_pregunta}` 
                      : `Question ${reporte.pregunta_id}`}
                  </h3>
                  <span 
                    className="reporte-estudiante-estado-badge"
                    style={{ backgroundColor: estadosColors[reporte.estado] || '#6c757d' }}
                  >
                    {estadosLabels[reporte.estado] || reporte.estado}
                  </span>
                </div>
                <div className="reporte-estudiante-fecha">
                  {new Date(reporte.fecha_creacion).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </div>
              </div>

              <div className="reporte-estudiante-body">
                <div className="reporte-estudiante-tipo">
                  <strong>Error Type:</strong> {tiposErrorLabels[reporte.tipo_error] || reporte.tipo_error}
                </div>

                {reporte.pregunta_texto && (
                  <div className="reporte-estudiante-pregunta">
                    <strong>Question:</strong>
                    <div className="reporte-estudiante-pregunta-texto">
                      {reporte.pregunta_texto}
                    </div>
                  </div>
                )}

                <div className="reporte-estudiante-descripcion">
                  <strong>Description:</strong>
                  <div className="reporte-estudiante-descripcion-texto">
                    {reporte.descripcion}
                  </div>
                </div>

                {reporte.comentario_admin && (
                  <div className="reporte-estudiante-comentario-admin">
                    <strong>Admin Response:</strong>
                    <div className="reporte-estudiante-comentario-texto">
                      {reporte.comentario_admin}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ReportesErroresEstudiante;



